import { render } from "./HeroiconsOutlineCurrencyBangladeshi.vue?vue&type=template&id=b8e12472"
const script = {}

import exportComponent from "C:\\Users\\ernes\\.ssh\\bipay-laravel-reportes\\vendor\\laravel\\nova\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"HeroiconsOutlineCurrencyBangladeshi.vue"]])

export default __exports__